import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import { findOptionTags } from 'utils/vnode';

import s from 'components/cardSelect/cardSelect.sss';

// Radio group rendered as a grid of cards. Fully controlled: pass `value` in, handle `onChange` out.
// Options are declared as <option> children, using the label / subtext / description / image attributes.
export default class CardSelect extends Component {
	s = s;

	constructor(props) {
		super(props);

		this.onChange = this.onChange.bind(this);
		this.renderOption = this.renderOption.bind(this);
	}

	onChange(e) {
		const value = e.target.value;
		if (value === this.props.value) return;
		this.props.onChange?.({ target: { name: this.props.name, value } });
	}

	renderImage(image) {
		if (!image) return;
		return (
			<div class={this.s.image} key="image">
				{typeof image === 'string' ? <img src={image} alt="" /> : image}
			</div>
		);
	}

	renderOption(option) {
		const { value, label, subtext, description, image, disabled, class: optionClass } = option.attributes;
		const text = description ?? option.children;

		return (
			<label class={joinClasses(this.s.card, optionClass)} key={value}>
				<input
					type="radio"
					name={this.props.name}
					value={value}
					checked={value === this.props.value}
					disabled={this.props.disabled || disabled}
					onChange={this.onChange}
				/>
				{this.renderImage(image)}
				{!!label && <div class={this.s.label} key="label">{label}</div>}
				{!!subtext && <div class={this.s.subtext} key="subtext">{subtext}</div>}
				{!!text && <div class={this.s.description} key="description">{text}</div>}
			</label>
		);
	}

	render(props) {
		return (
			<div
				class={joinClasses(this.s.wrapper, props.dark && this.s.dark, props.class)}
				role="radiogroup"
				aria-label={props.label}
			>
				{findOptionTags(props.children).map(this.renderOption)}
			</div>
		);
	}
}
